import { ethers } from "ethers";

import {get, readable, writable} from 'svelte/store';
import {
    provider,
    signer,
    address as my_address,
    unlock,
    unlocked,
    onWalletChange,
    correct_network,
    wallet_injected, onUnlocked,
    target_mainnet
} from "./wallet.js";


// export let contractAddress  = "0xf7C61204Ed5c058A317E0260e2E4C72976435b88"; //testnet
export let contractAddress  = "0x73D62Cc4D982E4120a12eE690E07B484AD013aBa"; //rinkeby

const MAINNET = "0x73D62Cc4D982E4120a12eE690E07B484AD013aBa";
const ZERO =    "0x0000000000000000000000000000000000000000"


let first_block = 8859000;



export const correct_address = contractAddress === MAINNET;

const contractAbi = ["event Approval(address indexed _owner,address indexed _approved,uint256 indexed _tokenId)","event ApprovalForAll(address indexed _owner,address indexed _operator,bool _approved)","event Transfer(address indexed _from,address indexed _to,uint256 indexed _tokenId)","function approve(address _approved,uint256 _tokenId) nonpayable","function balanceOf(address _owner) view returns(uint256 )","function getApproved(uint256 _tokenId) view returns(address )","function isApprovedForAll(address _owner,address _operator) view returns(bool )","function name() view returns(string _name)","function ownerOf(uint256 _tokenId) view returns(address )","function purchase(uint256 _tokenId) payable","function safeTransferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function safeTransferFrom(address _from,address _to,uint256 _tokenId,bytes data) nonpayable","function setApprovalForAll(address _operator,bool _approved) nonpayable","function supportsInterface(bytes4 interfaceID) view returns(bool )","function symbol() view returns(string _symbol)","function tokenByIndex(uint256 _index) view returns(uint256 )","function tokenOfOwnerByIndex(address _owner,uint256 _index) view returns(uint256 )","function tokenURI(uint256 _tokenId) view returns(string )","function totalSupply() view returns(uint256 )","function transferFrom(address _from,address _to,uint256 _tokenId) nonpayable","function withdraw() nonpayable"];

let contract = null;
let contractWithSigner = null;
export let me;

const BN = ethers.BigNumber;

const MINT_COST = BN.from(ethers.utils.parseEther('0.01'));


export let state = writable('initial'); //initial, loading, loaded, network, error



function clean_address(address){
    return String(address).toLowerCase();
}

export let owners =  [];
export let _owners = writable(owners);
export let my_tokens = {};
export let _my_tokens = writable(my_tokens);

export let _buttonsMinted = 0;
export let buttonsMinted = writable(_buttonsMinted);

// export let my_tokens_balance_total = BN.from(0);

const transactions = {
    // hash:{
    //     status: "pending",
    //     func: "purchase", //purchase
    //     params: {},
    // }
}

export let loader_i = writable(0);
export let loader_max = writable(1);


export let pending = {
    purchase: [],   //[tokenId]
    // solve: [],      //[tokenId]
}
export let _pending = writable(pending);
export let requested = {
    purchase: [],   //[tokenId]
    // solve: [],      //[tokenId]
}
export let _requested = writable(requested);

const parsed_events = {};

const callbacks = {
    Transfer: [],
    // Solved: [],

    transaction: {
        Submit: [],
        Confirm: [],
        Fail: [],
        Cancel: [],
    },
}
export function onTransfer(callback){
    callbacks.Transfer.push(callback);
}

export function onTransactionSubmit(callback){
    callbacks.transaction.Submit.push(callback);
}
export function onTransactionConfirm(callback){
    callbacks.transaction.Confirm.push(callback);
}
export function onTransactionFail(callback){
    callbacks.transaction.Fail.push(callback);
}
export function onTransactionCancel(callback){
    callbacks.transaction.Cancel.push(callback);
}


function transactionSubmitted(func,params){
    for(let i = 0; i < callbacks.transaction.Submit.length; i++){
        callbacks.transaction.Submit[i](func,params);
    }
}
function transactionConfirmed(func,params){
    for(let i = 0; i < callbacks.transaction.Confirm.length; i++){
        callbacks.transaction.Confirm[i](func,params);
    }
}
function transactionFailed(func,params){
    for(let i = 0; i < callbacks.transaction.Fail.length; i++){
        callbacks.transaction.Fail[i](func,params);
    }
}
function transactionCancelled(func,params){
    for(let i = 0; i < callbacks.transaction.Cancel.length; i++){
        callbacks.transaction.Cancel[i](func,params);
    }
}


// async function check_transaction_fail(hash){
//     return ;
// }


function Transferred(_from,_to,_tokenId){
    for(let i = 0; i < callbacks.Transfer.length; i++){
        callbacks.Transfer[i](_from,_to,_tokenId);
    }
}

function parse_Transfer(_from,_to,_tokenId){
    if(_from === me){
        delete my_tokens[_tokenId];
    }
    if(_to === me){
        my_tokens[_tokenId] = true;
    }
    _my_tokens.set(my_tokens);
    owners[_tokenId - 1] = _to;
    _owners.set(owners);


    if(_from === ZERO){
        _buttonsMinted++;
        buttonsMinted.set(_buttonsMinted);
    }

    Transferred(_from,_to,_tokenId);
}


function clear_transaction(hash){
    if(!transactions[hash]) return;
    const func = transactions[hash].func;
    const params = transactions[hash].params;
    switch (func){
        case "purchase":
        // case "solve":
            pending[func][params._tokenId] = false;
            break;
    }
    delete transactions[hash];
    _pending.set(pending);
    transactionConfirmed(func,params);
}


function parse_event(event){
    if(typeof event === "undefined") {
        // console.log('undefined event');
        return;
    }

    const index = event.logIndex+event.transactionHash.substr(1,12);

    if(parsed_events[index]) {
        // console.log('already parsed');
        return;
    }
    parsed_events[index] = true;

    if(transactions[event.transactionHash]){
        clear_transaction(event.transactionHash);
    }

    // console.log("::>>",event.event);

    switch (event.event){
        case "Transfer":
            // console.log("Transfer:",clean_address(event.args._from),
            //     clean_address(event.args._to),
            //     Number(event.args._tokenId._hex));
            parse_Transfer(
                clean_address(event.args._from),
                clean_address(event.args._to),
                Number(event.args._tokenId._hex)
            );
            break;
        default:
            // console.log("Other event:",event.event);
            break
    }


}


export async function connect(){

    console.log('connect');

    state.set('loading');

    contract = new ethers.Contract(contractAddress, contractAbi, provider);
    contractWithSigner = contract.connect(signer);

    me = clean_address(get(my_address));

    await processPastEvents();

    // await log_data();

    console.log('connect contract');

    contractWithSigner.on( "Transfer" , (author,oldValue,newValue,event)=>{
        if(typeof event === "undefined"){
            event = newValue;
        }
        parse_event(event);
    } );

    state.set('loaded');


}

function reset(){

    pending.purchase = [];
    _pending.set(pending);


    owners = [];
    _owners.set(owners);

    my_tokens = {};
    _my_tokens.set(my_tokens);

    for(let tx in transactions){
        delete transactions[tx];
    }

    for(let evt in parsed_events){
        delete parsed_events[evt];
    }
}



async function processPastEvents(){
    if(!contractWithSigner) return;


    let current_block = await provider.getBlockNumber();

    loader_max.set(current_block - first_block);

    // console.log(current_block);

    const interval = 50000;
    // const interval = 10000;

    let filter1 = contractWithSigner.filters.Transfer();
    ///5000
    //0
    // console.log('load events:');
    let processed = [];

    if(correct_address){
        for(let i = first_block; i < current_block - interval; i += interval){
            loader_i.set(i - first_block + interval);
            let all = await contractWithSigner.queryFilter(
                [filter1,
                    // filter2,
                    // filter3,
                    // filter4
                ],
                i,
                i + (interval - 1)
            );

            all.forEach(evt => {
                parse_event(evt);
            });
        }


        let all = await contractWithSigner.queryFilter(
            [filter1,
                // filter2,
                // filter3,
                // filter4
            ],
            current_block - interval,
        );
        all.forEach(evt => {
            parse_event(evt);
        });
    }else{
        let all = await contractWithSigner.queryFilter(
            [filter1,
                // filter2,
                // filter3,
                // filter4
            ]
        );
        all.forEach(evt => {
            parse_event(evt);
        });
    }


}


///Function

function cancel_transaction(func,params){
    switch (func){
        case "purchase":
            requested[func][params._tokenId] = false;
            break;
    }
    _requested.set(requested);

    transactionCancelled(func,params);
}
function request_transaction(func,params){
    switch (func){
        case "purchase":
            requested[func][params._tokenId] = true;
            break;
    }
    _requested.set(requested);
}

function register_transaction(tx,func,params){
    transactions[tx.hash] = {
        status: "pending",
        func: func,
        params: params,
    }
    switch (func){
        case "purchase":
            pending[func][params._tokenId] = true;
            requested[func][params._tokenId] = false;
            break;
    }
    _pending.set(pending);
    _requested.set(requested);

    transactionSubmitted(func,params);

    await_failure(tx.hash);
}

const await_failure = async(hash) => {
    const failure = (await provider.waitForTransaction( hash )).status === 0;
    if(failure){
        fail_transaction(hash);
    }
}

function fail_transaction(hash){
    if(!transactions[hash]) return;
    transactionFailed(transactions[hash].func,transactions[hash].params);
    // transactions[hash].status = "failed";

    const func = transactions[hash].func;
    const params = transactions[hash].params;
    switch (func){
        case "purchase":
            pending[func][params._tokenId] = false;
            break;
    }
    delete transactions[hash];
    _pending.set(pending);
}



function alert_error(e){
    switch(e.code){
        case 4001:
            ///cancel
            break;
        //TODO: default?
        case "INSUFFICIENT_FUNDS":
            alert("You don't have enough ETH to make this transaction");
            break;
        default:
            if(e.message.includes("execution reverted: difficulty")){
                alert("Error: Your mining result is no longer valid and your transaction will fail.");
            }else{
                alert("Metamask error: "+e.message);

            }
            break;

    }
}


export async function purchase(_tokenId){
    if(requested.purchase[_tokenId] || pending.purchase[_tokenId]) return;

    request_transaction('purchase',{
        _tokenId
    });
    try{


        const overrides = {value: MINT_COST.toString()};
        const tx =  await contractWithSigner.purchase(_tokenId,overrides);

        register_transaction(tx,'purchase', {
            _tokenId
        });
    }catch(e){
        cancel_transaction('purchase', {_tokenId});

        alert_error(e);
        return false;
    }
}

export async function ownerOf(_tokenId){
    return await contract.ownerOf(_tokenId);
}

export async function totalSupply(){
    return await contract.totalSupply();
}




async function unlockCallback(){
    if(!get(correct_network)){
        state.set("network");
    }else{
        await connect();
    }
    
    onWalletChange(async (correctNetwork)=>{
        reset();
        if(!correctNetwork){
            state.set("network");
        } else{
            await connect();
        }
    });
}

export default async function init() {
    if(typeof window.ethereum === "undefined"){
        return;
    }

    onUnlocked(unlockCallback);

    await unlock();
}


init();